import React, { useEffect, useState } from "react";
import CalenderDropdown from "@_common/CalenderDropdown";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import moment from "moment";
import qs from "query-string";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getValue } from "@utils/lodash";
import {
  downloadVendorComplianceMaster,
  getManageAuditScoreFilter,
  getVendorReportComplianceScoreCard,
  vendorReportsAccount,
} from "@services/reports.service";
import Loader from "@components/common/Loader";
import ScrollableReactTable from "@components/ScrollableDatatable";
import Notfound from "@components/Not-Found";
import PaginationPage from "@components/pagination/pagination";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { tableScoreColors } from "@_common/colors";
import { formatText, numberFormatter } from "@_common/text-helper";
import SearchHeader from "@components/common/SearchHeader";
import "./filter-form.scss";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import {
  submitVendorCheckpointTasks,
  vendorGetCheckpointInfoBySpecificLocation,
} from "@services/checkpoint.service";
import { CustomTable } from "./customTable";
import { handleDownloadOnClick } from "@_common/downloadfile";
import ReportsUploadModal from "./upload";
import { useParams } from "react-router-dom";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalBody,
} from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import { convertDateAsString } from "@_common/date-helpers";

interface ReportsVendorComplianceProps {}
const ReportsVendorCompliance: React.FunctionComponent<
  ReportsVendorComplianceProps
> = () => {
  let navigate = useNavigate();
  let mainParams = useParams();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [date, setDate] = useState<Date | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const [check, setCheck] = useState(false);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [request, setRequest] = useState<any>({
    state_id: "",
    city_id: "",
    // region_id: "",
    group_id: "",
    location_id: "",
    // vendor_id: "",
    audit_checkpoint_id: "",
    audit_type: "",
  });

  const [vendorInfo, setVendorInfo] = useState({});
  const [selectedIndex, setSelectedIndex] = useState<any>([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [comments, setComments] = useState("");

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0) {
      getData();
      setDate(new Date());
      // getRegionsList("", "");
      getGroupsList("", "");
      getStatesList("", "", "");
      getCitiesList("", "", "", "");
      getLocationsList("", "", "", "", "");
      // getVendorList("", "", "", "", "", "");
      getAuditCheckpointList("", "", "", "", "", "");
      // getAuditTypeList("","","","","","","","","");
      getAuditTypeList("", "", "", "", "", "", "");
    }
  }, []);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0) {
      getData();
      // getRegionsList("", "");
      getGroupsList("", "");
      getStatesList("", "", "");
      getCitiesList("", "", "", "");
      getLocationsList("", "", "", "", "");
      getVendorList("", "", "", "", "", "");
      getAuditCheckpointList("", "", "", "", "", "");
      getAuditTypeList("", "", "", "", "", "", "");

      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }

      if (params.limit) {
        setLimit(parseInt(params.limit));
      }

      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }

      //-----------------region & group-----------------//
      // if (getValue(params, `region_id`, "")) {
      //   getRegionsList("", getValue(params, `region_id`, ""));
      //   getGroupsList(
      //     "",
      //     getValue(params, `region_id`, ""),
      //     getValue(params, `group_id`, "")
      //   );
      // } else {
      //   getRegionsList("", getValue(params, `region_id`, ""));
      // }

      //-----------------state-----------------//

      if (getValue(params, `group_id`, "")) {
        getStatesList(
          "",
          // getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, "")
        );
      }

      //-----------------city-----------------//

      if (getValue(params, `state_id`, "")) {
        getCitiesList(
          "",
          // getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, ""),
          getValue(params, `city_id`, "")
        );
      }

      //-----------------location-----------------//
      if (getValue(params, `group_id`, "")) {
        getLocationsList(
          "",
          // getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, ""),
          getValue(params, `city_id`, ""),
          getValue(params, `location_id`, "")
        );
      }
      //-----------------vendor-----------------//
      if (getValue(params, `location_id`, "")) {
        // getVendorList(
        //   "",
        //   // getValue(params, `region_id`, ""),
        //   getValue(params, `group_id`, ""),
        //   getValue(request, `state_id`, ""),
        //   getValue(request, `city_id`, ""),
        //   getValue(params, `location_id`, ""),
        //   // getValue(params, `vendor_id`, "")
        // );

        getAuditCheckpointList(
          "",
          // getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          // getValue(params, `vendor_id`, ""),
          getValue(params, `audit_checkpoint_id`, "")
        );

      }

      //-----------------audit type-----------------//
      if (getValue(params, `audit_checkpoint_id`, "")) {
        getAuditTypeList(
          "",
          // getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          // getValue(params, `vendor_id`, ""),
          getValue(params, `audit_checkpoint_id`, ""),
          getValue(params, `audit_type`, "")
        );
      }

      setRequest({
        ...request,
        // region_id: getValue(params, `region_id`, ""),
        group_id: getValue(params, `group_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        city_id: getValue(params, `city_id`, ""),
        location_id: getValue(params, `location_id`, ""),
        // vendor_id: getValue(params, `vendor_id`, ""),
        audit_type: getValue(params, `audit_type`, ""),
        audit_checkpoint_id: getValue(params, `audit_checkpoint_id`, ""),
      });
    }
  }, [window.location.href]);

  /* -------------------------------------------------------------------------- */
  /*                               Date section                             */
  /* -------------------------------------------------------------------------- */
  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    if (dates && dates !== "Invalid date") {
      let payload: any = {
        date: dates,
      };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  // const getData = async () => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = date ? date : new Date();
  //   let user = JSON.parse(getValue(localStorage, `user`, {}));
  //   let vendor_id = getValue(user, `vendor.id`, "");
  //   let user_id = getValue(user, `id`, "");
  //   let payload: any = {
  //     month: params.date
  //       ? params.date.split("-")[1]
  //       : date
  //       ? moment(date).format("MM")
  //       : moment(dates).format("MM"),
  //     year: params.date
  //       ? params.date.split("-")[0]
  //       : date
  //       ? moment(date).format("YYYY")
  //       : moment(dates).format("YYYY"),
  //     user_id: user_id,
  //     page_no: params.page_no ? parseInt(params.page_no) : 1,
  //     page_size: params.limit ? parseInt(params.limit) : 10,
  //     search_text: params.search_text,
  //     sort_by: params.sort_by,
  //     is_redirect: true,
  //     region_id: params.region_id,
  //     group_id: params.group_id,
  //     location_id: params.location_id,
  //     vendor_id:params.vendor_id ? params.vendor_id :  vendor_id,
  //     // audit_type: params.audit_type,
  //     state_id: getValue(params, `state_id`, ""),
  //     city_id: getValue(params, `city_id`, ""),
  //     is_active: true
  //   };
  //   // removing null values
  //   Object.keys(payload).forEach((key) => {
  //     if (!payload[key] || payload[key] === undefined) {
  //       delete payload[key];
  //     }
  //   });
  //   let queryRequest = qs.stringify(payload);
  //   setIsLoading(true);
  //   try {
  //     let resp = await vendorGetCheckpointInfoBySpecificLocation(queryRequest);
  //     if (resp) {
  //       setIsLoading(false);
  //       setList(
  //         getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
  //           ...item,
  //           checkpoint_id: getValue(item, `checkpoint.checkpoint_id`, ""),
  //           category: getValue(item, `checkpoint.category_of_law.text`, ""),
  //           location_name: getValue(item, `location.location_name`, ""),
  //           region_name: getValue(item, `location.region.text`, ""),
  //           group_name: getValue(item, `location.group.group_name`, ""),
  //           legislation_rule: getValue(item, `checkpoint.legislation_rule.rule_name`, ""),
  //           recent_comments: getValue(item, `recent_comment.comments`, ""),
  //           events: getValue(item, `checkpoint.events.text`, ""),
  //           vendor_name: getValue(item, `vendor.vendor_name`, ""),
  //           status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
  //           created_date: moment(getValue(item, `created_at`, "")).format(
  //             "DD MMM YYYY, hh:mm a"
  //           ),
  //           // audit_date : moment(getValue(item, `audited_at`, "")).format(
  //           //   "DD MMM YYYY"
  //           // ),
  //           audit_date: getValue(item, `audited_at`, "")
  //           ? moment(getValue(item, `audited_at`, "")).format("DD MMM YYYY")
  //           : " ",
  //           compliance_activity: getValue(
  //             item,
  //             `checkpoint.compliance_activity`,
  //             ""
  //           ),
  //           // audit_status: formatText(getValue(item, `audit_status`, "")),
  //           audit_status: (
  //             <div
  //               style={{
  //                 color:
  //                 getValue(item, `audit_status`, "") === "NON_COMPLIED"
  //                   ? "#d7242e" // Red
  //                   : getValue(item, `audit_status`, "") === "COMPLIED"
  //                   ? "#28a745" // Green
  //                   : getValue(item, `audit_status`, "") === "NOT_APPLICABLE"
  //                   ? "#007bff" // Blue
  //                   : getValue(item, `audit_status`, "") === "PENDING_AUDIT"
  //                   ? "#ffa500" // Orange
  //                   : getValue(item, `audit_status`, "") === "NOT_SUBMITTED"
  //                   ? "#808080" // Grey
  //                   : "", // Default color

  //               }}
  //             >
  //               {formatText(getValue(item, `audit_status`, ""))}
  //             </div>
  //           ),

  //           compliance_rule : getValue(
  //             item,
  //             `checkpoint.legislation_rule.rule_name`,
  //             ""
  //           ),
  //           legislation: getValue(item, `checkpoint.legislation.legislation_name`, ""),
  //         }))
  //       );

  //       // const transformedData = getValue(resp, `data.vendors_checkpoint`, []).flatMap((vc:any) => {
  //       //   const mainEntry = { ...vc, type: 'main' };
  //       //   const documentEntries = vc.documents.map((doc:any, index:any) => ({
  //       //     ...doc,
  //       //     type: 'document',
  //       //     parentId: vc.id,
  //       //     id: `${vc.id}_doc_${index}`, // Ensure a unique ID
  //       //   }));
  //       //   return [mainEntry, ...documentEntries];
  //       // });

  //       // setList(transformedData);

  //       setTotalCount(getValue(resp, `data.pagination.total`, 0));
  //     } else {
  //       setIsLoading(false);
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //   }
  // };

  // const getData = async () => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = date ? date : new Date();
  //   let user = JSON.parse(getValue(localStorage, `user`, {}));
  //   let vendor_id = getValue(user, `vendor.id`, "");
  //   let user_id = getValue(user, `id`, "");
  //   let payload: any = {
  //     month: params.date
  //       ? params.date.split("-")[1]
  //       : date
  //       ? moment(date).format("MM")
  //       : moment(dates).format("MM"),
  //     year: params.date
  //       ? params.date.split("-")[0]
  //       : date
  //       ? moment(date).format("YYYY")
  //       : moment(dates).format("YYYY"),
  //     user_id: user_id,
  //     page_no: params.page_no ? parseInt(params.page_no) : 1,
  //     page_size: params.limit ? parseInt(params.limit) : 10,
  //     search_text: params.search_text,
  //     sort_by: params.sort_by,
  //     is_redirect: true,
  //     region_id: params.region_id,
  //     group_id: params.group_id,
  //     location_id: params.location_id,
  //     vendor_id: params.vendor_id ? params.vendor_id : vendor_id,
  //     state_id: getValue(params, `state_id`, ""),
  //     city_id: getValue(params, `city_id`, ""),
  //     is_active: true,
  //   };

  //   // Remove null or undefined values
  //   Object.keys(payload).forEach((key) => {
  //     if (!payload[key] || payload[key] === undefined) {
  //       delete payload[key];
  //     }
  //   });

  //   let queryRequest = qs.stringify(payload);
  //   setIsLoading(true);

  //   try {
  //     let resp = await vendorGetCheckpointInfoBySpecificLocation(queryRequest);
  //     if (resp) {
  //       setIsLoading(false);

  //       // Transform the data to include both main entries and document entries
  //       // const transformedData = getValue(resp, `data.vendors_checkpoint`, []).flatMap((item:any) => {
  //       //   // Main data row
  //       //   const mainEntry = {
  //       //     type: "data",
  //       //     ...item,
  //       //     checkpoint_id: getValue(item, `checkpoint.checkpoint_id`, ""),
  //       //     category: getValue(item, `checkpoint.category_of_law.text`, ""),
  //       //     location_name: getValue(item, `location.location_name`, ""),
  //       //     region_name: getValue(item, `location.region.text`, ""),
  //       //     group_name: getValue(item, `location.group.group_name`, ""),
  //       //     legislation_rule: getValue(item, `checkpoint.legislation_rule.rule_name`, ""),
  //       //     recent_comments: getValue(item, `recent_comment.comments`, ""),
  //       //     events: getValue(item, `checkpoint.events.text`, "") || "N/A",
  //       //     vendor_name: getValue(item, `vendor.vendor_name`, ""),
  //       //     status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
  //       //     created_date: moment(getValue(item, `created_at`, "")).format("DD MMM YYYY, hh:mm a"),
  //       //     audit_date: getValue(item, `audited_at`, "")
  //       //       ? moment(getValue(item, `audited_at`, "")).format("DD MMM YYYY")
  //       //       : " ",
  //       //     compliance_activity: getValue(item, `checkpoint.compliance_activity`, ""),
  //       //     audit_status: (
  //       //       <div
  //       //         style={{
  //       //           color:
  //       //             getValue(item, `audit_status`, "") === "NON_COMPLIED"
  //       //               ? "#d7242e" // Red
  //       //               : getValue(item, `audit_status`, "") === "COMPLIED"
  //       //               ? "#28a745" // Green
  //       //               : getValue(item, `audit_status`, "") === "NOT_APPLICABLE"
  //       //               ? "#007bff" // Blue
  //       //               : getValue(item, `audit_status`, "") === "PENDING_AUDIT"
  //       //               ? "#ffa500" // Orange
  //       //               : getValue(item, `audit_status`, "") === "NOT_SUBMITTED"
  //       //               ? "#808080" // Grey
  //       //               : "", // Default color
  //       //         }}
  //       //       >
  //       //         {formatText(getValue(item, `audit_status`, ""))}
  //       //       </div>
  //       //     ),
  //       //     compliance_rule: getValue(item, `checkpoint.legislation_rule.rule_name`, ""),
  //       //     legislation: getValue(item, `checkpoint.legislation.legislation_name`, ""),
  //       //   };

  //       //   // Document rows (if documents exist)
  //       //   const documentEntries = (item.documents || []).map((doc:any, index:any) => ({
  //       //     type: "documents",
  //       //     parentId: item.id,
  //       //     id: `${item.id}_doc_${index}`, // Unique ID for document row
  //       //     documents: item.documents, // Entire documents array for rendering
  //       //   }));

  //       //   // Return main entry followed by document entries (if any)
  //       //   return [mainEntry, ...(documentEntries.length > 0 ? documentEntries : [])];
  //       // });

  //       const transformedData = getValue(resp, `data.vendors_checkpoint`, []).flatMap((item:any) => {
  //         const mainEntry = {
  //           type: "data",
  //           ...item,
  //           checkpoint_id: getValue(item, `checkpoint.checkpoint_id`, ""),
  //           category: getValue(item, `checkpoint.category_of_law.text`, ""),
  //           location_name: getValue(item, `location.location_name`, ""),
  //           region_name: getValue(item, `location.region.text`, ""),
  //           group_name: getValue(item, `location.group.group_name`, ""),
  //           legislation_rule: getValue(item, `checkpoint.legislation_rule.rule_name`, ""),
  //           recent_comments: getValue(item, `recent_comment.comments`, ""),
  //           events: getValue(item, `checkpoint.events.text`, "") || "N/A",
  //           vendor_name: getValue(item, `vendor.vendor_name`, ""),
  //           status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
  //           created_date: moment(getValue(item, `created_at`, "")).format("DD MMM YYYY, hh:mm a"),
  //           audit_date: getValue(item, `audited_at`, "")
  //             ? moment(getValue(item, `audited_at`, "")).format("DD MMM YYYY")
  //             : " ",
  //           compliance_activity: getValue(item, `checkpoint.compliance_activity`, ""),
  //           audit_status: (
  //             <div
  //               style={{
  //                 color:
  //                   getValue(item, `audit_status`, "") === "NON_COMPLIED"
  //                     ? "#d7242e"
  //                     : getValue(item, `audit_status`, "") === "COMPLIED"
  //                     ? "#28a745"
  //                     : getValue(item, `audit_status`, "") === "NOT_APPLICABLE"
  //                     ? "#007bff"
  //                     : getValue(item, `audit_status`, "") === "PENDING_AUDIT"
  //                     ? "#ffa500"
  //                     : getValue(item, `audit_status`, "") === "NOT_SUBMITTED"
  //                     ? "#808080"
  //                     : "",
  //               }}
  //             >
  //               {formatText(getValue(item, `audit_status`, ""))}
  //             </div>
  //           ),
  //           compliance_rule: getValue(item, `checkpoint.legislation_rule.rule_name`, ""),
  //           legislation: getValue(item, `checkpoint.legislation.legislation_name`, ""),
  //         };

  //         const documentEntries = (item.documents || []).map((doc:any, index:any) => ({
  //           type: "documents",
  //           parentId: item.id,
  //           id: `${item.id}_doc_${index}`,
  //           documents: item.documents,
  //         }));

  //         return [mainEntry, ...(documentEntries.length > 0 ? documentEntries : [])];
  //       });
  //       // Set the transformed data to state
  //       setList(transformedData);
  //       setTotalCount(getValue(resp, `data.pagination.total`, 0));
  //     } else {
  //       setIsLoading(false);
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //   }
  // };

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let user = JSON.parse(getValue(localStorage, `user`, {}));
    let vendor_id = getValue(user, `vendor.id`, "");
    let user_id = getValue(user, `id`, "");

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      user_id: user_id,
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      is_redirect: true,
      // region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id ? params.vendor_id : vendor_id,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_active: true,
      audit_status: params.audit_type ? params.audit_type : params.audit_status,
      legislation_rule_id: params.audit_checkpoint_id,
    };

    // Remove null or undefined values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });

    let queryRequest = qs.stringify(payload);
    setIsLoading(true);

    try {
      let resp = await vendorGetCheckpointInfoBySpecificLocation(queryRequest);
      if (resp) {
        setIsLoading(false);

        // Transform the data to include documents in the main row
        const transformedData = getValue(
          resp,
          `data.vendors_checkpoint`,
          []
        ).map((item: any) => ({
          type: "data",
          ...item,
          checkpoint_id: getValue(item, `checkpoint.checkpoint_id`, ""),
          category: getValue(item, `checkpoint.category_of_law.text`, ""),
          location_name: getValue(item, `location.location_name`, ""),
          region_name: getValue(item, `location.region.text`, ""),
          group_name: getValue(item, `location.group.group_name`, ""),
          legislation_rule: getValue(
            item,
            `checkpoint.legislation_rule.rule_name`,
            ""
          ),
          recent_comments: getValue(item, `recent_comment.comments`, ""),
          events: getValue(item, `checkpoint.events.text`, "") || "N/A",
          vendor_name: getValue(item, `vendor.vendor_name`, ""),
          status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
          created_date: moment(getValue(item, `created_at`, "")).format(
            "DD MMM YYYY, hh:mm a"
          ),
          audit_date: getValue(item, `audited_at`, "")
            ? moment(getValue(item, `audited_at`, "")).format("DD MMM YYYY")
            : " ",
          compliance_activity: getValue(
            item,
            `checkpoint.compliance_activity`,
            ""
          ),
          audit_status: (
            <div
              style={{
                color:
                  getValue(item, `audit_status`, "") === "NON_COMPLIED"
                    ? "#d7242e"
                    : getValue(item, `audit_status`, "") === "COMPLIED"
                    ? "#28a745"
                    : getValue(item, `audit_status`, "") === "NOT_APPLICABLE"
                    ? "#007bff"
                    : getValue(item, `audit_status`, "") === "PENDING_AUDIT"
                    ? "#ffa500"
                    : getValue(item, `audit_status`, "") === "NOT_SUBMITTED"
                    ? "#808080"
                    : getValue(item, `audit_status`, "") ===
                      "SEND_BACK_TO_VENDOR"
                    ? "#ff0000" // Red for "Send Back to Vendor"
                    : "",
              }}
            >
              {formatText(getValue(item, `audit_status`, ""))}
            </div>
          ),
          compliance_rule: getValue(
            item,
            `checkpoint.legislation_rule.rule_name`,
            ""
          ),
          legislation: getValue(
            item,
            `checkpoint.legislation.legislation_name`,
            ""
          ),
          documents: item.documents || [], // Include all documents in the main row
        }));

        setList(transformedData);
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               React Datatable                              */
  /* -------------------------------------------------------------------------- */
  const searchParams = new URLSearchParams(window.location.search);
  const paramsNew = Object.fromEntries(searchParams.entries());

  const dateParam = paramsNew?.date ? new Date(paramsNew.date) : new Date(); // Get the date from params or use the current date

  const getMonthNameWithYear = (date: Date, offset: number) => {
    const adjustedDate = new Date(date);
    adjustedDate.setMonth(date.getMonth() - offset); // Subtract months to get previous month
    const month = adjustedDate.toLocaleString("default", { month: "short" });
    const year = adjustedDate.getFullYear().toString().slice(-2);
    return `${month}-${year}`;
  };

  // Use the new function to get month-year combinations
  const currentMonthName = getMonthNameWithYear(dateParam, 0);
  const prevMonth1Name = getMonthNameWithYear(dateParam, 1);
  const prevMonth2Name = getMonthNameWithYear(dateParam, 2);
  const prevMonth3Name = getMonthNameWithYear(dateParam, 3);

  const year = paramsNew?.date
    ? new Date(paramsNew.date).getFullYear()
    : new Date().getFullYear();

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const columns1 = React.useMemo(
    () => [
      {
        Header: "Region",
        accessor: "region_name",
        width: 80,
      },

      {
        Header: "Account",
        accessor: "group_name",
        width: 120,
      },
      {
        Header: "Site",
        accessor: "location_name",
        width: 120,
      },
      {
        Header: "Vendor",
        accessor: "vendor_name",
        width: 100,
      },
      {
        Header: "Title",
        accessor: "legislation_rule",
        width: 150,
      },
      {
        Header: "Risk",
        accessor: "events",
        width: 150,
      },
      {
        Header: "Audit Status",
        width: 100,
        accessor: "audit_status",
      },

      {
        Header: "Audit Comments",
        accessor: "recent_comments",
        width: 200,
      },
      {
        Header: "Audit Date",
        accessor: "audit_date",
        width: 150,
      },
    ],
    [paramsNew.date]
  );

  // const columns = React.useMemo(
  //   () => [
  //     {
  //       Header: "Region",
  //       accessor: "region_name",
  //       width: 80,
  //       Cell: ({ row }:any) => (row.original.type === "data" ? row.original.region_name : null),
  //     },
  //     {
  //       Header: "Account",
  //       accessor: "group_name",
  //       width: 120,
  //       Cell: ({ row }:any) => (row.original.type === "data" ? row.original.group_name : null),
  //     },
  //     {
  //       Header: "Site",
  //       accessor: "location_name",
  //       width: 120,
  //       Cell: ({ row }:any) => (row.original.type === "data" ? row.original.location_name : null),
  //     },
  //     {
  //       Header: "Vendor",
  //       accessor: "vendor_name",
  //       width: 100,
  //       Cell: ({ row }:any) => (row.original.type === "data" ? row.original.vendor_name : null),
  //     },
  //     {
  //       Header: "Title",
  //       accessor: "legislation_rule",
  //       width: 150,
  //       Cell: ({ row }:any) => (row.original.type === "data" ? row.original.legislation_rule : null),
  //     },
  //     {
  //       Header: "Risk",
  //       accessor: "events",
  //       width: 150,
  //       Cell: ({ row }:any) => (row.original.type === "data" ? row.original.events : null),
  //     },
  //     {
  //       Header: "Audit Status",
  //       width: 100,
  //       accessor: "audit_status",
  //       Cell: ({ row }:any) => (row.original.type === "data" ? row.original.audit_status : null),
  //     },
  //     {
  //       Header: "Audit Comments",
  //       accessor: "recent_comments",
  //       width: 200,
  //       Cell: ({ row }:any) => (row.original.type === "data" ? row.original.recent_comments : null),
  //     },
  //     {
  //       Header: "Audit Date",
  //       accessor: "audit_date",
  //       width: 150,
  //       Cell: ({ row }:any) => (row.original.type === "data" ? row.original.audit_date : null),
  //     },
  //   ],
  //   [paramsNew.date]
  // );

  const columns = React.useMemo(
    () => [
      // {
      //   Header: "Region",
      //   accessor: "region_name",
      //   width: 80,
      //   Cell: ({ row }: any) =>
      //     row.original.type === "data" ? row.original.region_name : null,
      // },
      {
        Header: "Account",
        accessor: "group_name",
        width: 120,
        Cell: ({ row }: any) =>
          row.original.type === "data" ? row.original.group_name : null,
      },
      {
        Header: "Site",
        accessor: "location_name",
        width: 120,
        Cell: ({ row }: any) =>
          row.original.type === "data" ? row.original.location_name : null,
      },
      // {
      //   Header: "Vendor",
      //   accessor: "vendor_name",
      //   width: 100,
      //   Cell: ({ row }: any) =>
      //     row.original.type === "data" ? row.original.vendor_name : null,
      // },
      {
        Header: "Title",
        accessor: "legislation_rule",
        width: 150,
        Cell: ({ row }: any) =>
          row.original.type === "data" ? row.original.legislation_rule : null,
      },
      {
        Header: "Risk",
        accessor: "events",
        width: 150,
        Cell: ({ row }: any) =>
          row.original.type === "data" ? row.original.events : null,
      },
      {
        Header: "Audit Status",
        width: 100,
        accessor: "audit_status",
        Cell: ({ row }: any) =>
          row.original.type === "data" ? row.original.audit_status : null,
      },
      {
        Header: "Audit Comments",
        accessor: "recent_comments",
        width: 200,
        Cell: ({ row }: any) =>
          row.original.type === "data" ? row.original.recent_comments : null,
      },
      {
        Header: "Audit Date",
        accessor: "audit_date",
        width: 150,
        Cell: ({ row }: any) =>
          row.original.type === "data" ? row.original.audit_date : null,
      },
      // {
      // 	Header: "Action",
      // 	width: 250,
      // 	Cell: ({ row }: any) => {

      //     const vendorCheckpointAuditCycles = getValue(row.original, 'vendor_checkpoint_audit_cycles', []);
      //     // const releaseCycleId = vendorCheckpointAuditCycles
      //     // .find((cycle:any) => {
      //     //   const releaseDateAuditCycle = getValue(cycle, 'release_date_audit_cycle', null);
      //     //   return releaseDateAuditCycle && Object.keys(releaseDateAuditCycle).length > 0;
      //     // })?.id;

      //     const releaseAuditCycleId = vendorCheckpointAuditCycles
      //       .find((cycle:any) => {
      //         const releaseDateAuditCycle = getValue(cycle, 'release_date_audit_cycle', null);
      //         return releaseDateAuditCycle && Object.keys(releaseDateAuditCycle).length > 0;
      //       })?.release_date_audit_cycle?.id;
      //       const id = getValue(row.original, `id`, "");

      // 		return (
      // 			<>
      //         <button className="btn btn-primary"

      //           onClick={() => handleModalUpload(row.original)}
      //                         >
      //           Upload
      //         </button>

      //         <button className="btn btn-primary"
      //         onClick={checkUpload.some((item:any) => item.upload_status === "NOT_UPLOADED") ? handleModal2 : handleSubmitTask}
      //         >
      //           Submit
      //         </button>
      // 			</>
      // 		);
      // 	},
      // },

      // {
      //   Header: "Action",
      //   width: 250,
      //   Cell: ({ row }: any) => {
      //     const vendorCheckpointAuditCycles = getValue(
      //       row.original,
      //       "vendor_checkpoint_audit_cycles",
      //       []
      //     );
      //     const releaseAuditCycleId = vendorCheckpointAuditCycles.find(
      //       (cycle: any) => {
      //         const releaseDateAuditCycle = getValue(
      //           cycle,
      //           "release_date_audit_cycle",
      //           null
      //         );
      //         return (
      //           releaseDateAuditCycle &&
      //           Object.keys(releaseDateAuditCycle).length > 0
      //         );
      //       }
      //     )?.release_date_audit_cycle?.id;
      //     const id = getValue(row.original, `id`, "");
      //     const auditStatus = getValue(row.original, "audit_status", "");

      //     const handleSubmit = () => {
      //       console.log(releaseAuditCycleId, "=-releaseAuditCycleId=>");
      //       // Call handleChangeCheckbox first
      //       handleChangeCheckbox(id, releaseAuditCycleId);

      //       // Then call handleModal2 or handleSubmitTask based on the condition
      //       if (
      //         checkUpload.some(
      //           (item: any) => item.upload_status === "NOT_UPLOADED"
      //         )
      //       ) {
      //         handleModal2();
      //       } else {
      //         setSelectedIndex([id]);
      //         handleSubmitTask();
      //       }
      //     };
      //     if (
      //       typeof auditStatus === "object" &&
      //       ["pending audit", "complied"].includes(
      //         auditStatus?.props?.children?.toLowerCase()
      //       )
      //     ) {
      //       return null;
      //     }

      //     return (
      //       <>
      //         <div className="d-flex gap-1">
      //           <button
      //             className="btn common-button p-2 me-2"
      //             onClick={() => handleModalUpload(row.original)}
      //           >
      //             Upload Document
      //           </button>

      //           <button
      //             className="btn btn-primary p-2"
      //             onClick={handleSubmit}
      //             disabled={
      //               typeof row.original.audit_status === "object" &&
      //               row.original.audit_status?.props?.children?.toLowerCase() ===
      //                 "pending audit"
      //             }
      //           >
      //             Submit
      //           </button>
      //         </div>
      //       </>
      //     );
      //   },
      // },

      // {
      //   Header: "Action",
      //   width: 250,
      //   Cell: ({ row }: any) => {
      //     const vendorCheckpointAuditCycles = getValue(
      //       row.original,
      //       "vendor_checkpoint_audit_cycles",
      //       []
      //     );
      
      //     const hasReleaseDateAuditCycle = vendorCheckpointAuditCycles.some(
      //       (cycle: any) => getValue(cycle, "release_date_audit_cycle", null)
      //     );
      
      //     if (!hasReleaseDateAuditCycle) {
      //       return "";
      //     }
      
      //     const releaseAuditCycleId = vendorCheckpointAuditCycles.find(
      //       (cycle: any) => getValue(cycle, "release_date_audit_cycle", null)
      //     )?.release_date_audit_cycle?.id;
      
      //     const id = getValue(row.original, "id", "");
      //     const auditStatus = getValue(row.original, "audit_status", "");
      
      //     const handleSubmit = () => {
      //       console.log(releaseAuditCycleId, "=-releaseAuditCycleId=>");
      //       handleChangeCheckbox(id, releaseAuditCycleId);
      
      //       if (
      //         checkUpload.some((item: any) => item.upload_status === "NOT_UPLOADED")
      //       ) {
      //         handleModal2();
      //       } else {
      //         setSelectedIndex([id]);
      //         handleSubmitTask();
      //       }
      //     };
      
      //     if (
      //       typeof auditStatus === "object" &&
      //       ["pending audit", "complied"].includes(
      //         auditStatus?.props?.children?.toLowerCase()
      //       )
      //     ) {
      //       return null;
      //     }
      
      //     return (
      //       <>
      //         <div className="d-flex gap-1">
      //           <button
      //             className="btn common-button p-2 me-2"
      //             onClick={() => handleModalUpload(row.original)}
      //           >
      //             Upload Document
      //           </button>
      
      //           <button
      //             className="btn btn-primary p-2"
      //             onClick={handleSubmit}
      //             disabled={
      //               typeof row.original.audit_status === "object" &&
      //               row.original.audit_status?.props?.children?.toLowerCase() ===
      //                 "pending audit"
      //             }
      //           >
      //             Submit
      //           </button>
      //         </div>
      //       </>
      //     );
      //   },
      // }

      // {
      //   Header: "Action",
      //   width: 250,
      //   Cell: ({ row }: any) => {
      //     const vendorCheckpointAuditCycles = getValue(
      //       row.original,
      //       "vendor_checkpoint_audit_cycles",
      //       []
      //     );
      
      //     // Get release date audit cycle
      //     const releaseAuditCycle = vendorCheckpointAuditCycles.find(
      //       (cycle: any) => getValue(cycle, "release_date_audit_cycle", null)
      //     )?.release_date_audit_cycle;
      
      //     // If no valid audit cycle exists, return empty
      //     if (!releaseAuditCycle) return "";
      
      //     // Date validation
      //     const getLocalDateString = () => {
      //       const d = new Date();
      //       const year = d.getFullYear();
      //       const month = String(d.getMonth() + 1).padStart(2, '0');
      //       const day = String(d.getDate()).padStart(2, '0');
      //       return `${year}-${month}-${day}`;
      //     };
      
      //     const today = getLocalDateString();
      //     const startDate = releaseAuditCycle.start_date;
      //     const cutoffDate = releaseAuditCycle.cutoff_date;
      
      //     // Check if current date is within valid range
      //     if (today < startDate || today > cutoffDate) return "";
      
      //     // Audit status check
      //     const auditStatus = getValue(row.original, "audit_status", "");
      //     let auditStatusValue = "";
          
      //     if (typeof auditStatus === "object") {
      //       auditStatusValue = auditStatus?.props?.children?.toLowerCase() || "";
      //     } else {
      //       auditStatusValue = (auditStatus || "").toLowerCase();
      //     }
      
      //     // Don't show buttons for these statuses
      //     if (["pending audit", "complied"].includes(auditStatusValue)) return null;
      
      //     // Rest of your existing logic
      //     const releaseAuditCycleId = releaseAuditCycle.id;
      //     const id = getValue(row.original, "id", "");
      
      //     const handleSubmit = () => {
      //       console.log(releaseAuditCycleId, "=-releaseAuditCycleId=>");
      //       handleChangeCheckbox(id, releaseAuditCycleId);

      //       setSelectedIndex(id);

      //       let selectedCheck = list.filter((item: any) => {
      //         if (selectedIndex.includes(getValue(item, `id`, ""))) return item;
      //       });
            
      //       console.log(selectedCheck, "selectedCheck");
          
      //       let checkUpload: any =
      //         getValue(selectedCheck, `length`, 0) > 0
      //           ? selectedCheck.filter(
      //               (item: any) =>
      //                 !getValue(item, `is_submitted`, "") ||
      //                 getValue(item, `upload_status`, "") === "UPLOADED"
      //             )
      //           : [];          
      
      //           console.log(checkUpload, "checkUpload");


      //       // if (checkUpload.some((item: any) => item.upload_status === "NOT_UPLOADED")) {
      //       //   handleModal2();
      //       // } else {
      //       //   setSelectedIndex([id]);
      //         // handleSubmitTask(id);
      //       // }
      //     };
      
      //     return (
      //       <div className="d-flex gap-1">
      //         <button
      //           className="btn common-button p-2 me-2"
      //           onClick={() => handleModalUpload(row.original)}
      //         >
      //           Upload Document
      //         </button>
      
      //         <button
      //           className="btn btn-primary p-2"
      //           onClick={handleSubmit}
      //           disabled={auditStatusValue === "pending audit"}
      //         >
      //           Submit
      //         </button>
      //       </div>
      //     );
      //   },
      // }

        // Working Code
      // {
      //   Header: "Action",
      //   width: 250,
      //   Cell: ({ row }: any) => {
      //     const vendorCheckpointAuditCycles = getValue(
      //       row.original,
      //       "vendor_checkpoint_audit_cycles",
      //       []
      //     );
      
      //     // Get release date audit cycle from the current row's data
      //     const releaseAuditCycle = vendorCheckpointAuditCycles.find(
      //       (cycle: any) => getValue(cycle, "release_date_audit_cycle", null)
      //     )?.release_date_audit_cycle;
      
      //     // If no valid audit cycle exists, return empty
      //     if (!releaseAuditCycle) return "";
      
      //     // Date validation
      //     const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
      //     const startDate = releaseAuditCycle.start_date;
      //     const cutoffDate = releaseAuditCycle.cutoff_date;
      
      //     // Check if current date is within valid range
      //     if (today < startDate || today > cutoffDate) return "";
      
      //     // Get audit status directly from row data
      //     const auditStatus = getValue(row, "original.audit_status.props.children", "").toLowerCase();
      //     const documents = getValue(row.original, "documents", []);
      //     const uploadStatus = documents.length > 0 ? "UPLOADED" : "NOT_UPLOADED";
      
      //     // Determine if action buttons should be shown
      //     if (["pending audit", "complied"].includes(auditStatus)) return null;
      
      //     const handleSubmit = () => {
      //       const id = row.original.id;
      //       const releaseCycleId = releaseAuditCycle.id;
      
      //       if (uploadStatus === "NOT_UPLOADED") {
      //         handleModal2();
      //         setSelectedIndex(id); // Track the current ID for comments
      //       } else {
      //         handleSubmitTask(id, releaseCycleId);
      //       }
      //     };
      
      //     return (
      //       <div className="d-flex gap-1">
      //         <button
      //           className="btn common-button p-2 me-2"
      //           onClick={() => handleModalUpload(row.original)}
      //         >
      //           Upload Document
      //         </button>
      
      //         <button
      //           className="btn btn-primary p-2"
      //           onClick={handleSubmit}
      //           disabled={auditStatus === "pending audit"}
      //         >
      //           Submit
      //         </button>
      //       </div>
      //     );
      //   },
      // }

      {
        Header: "Action",
        width: 250,
        Cell: ({ row }: any) => {
          const vendorCheckpointAuditCycles = getValue(
            row.original,
            "vendor_checkpoint_audit_cycles",
            []
          );
      
          // Get release date audit cycle from the current row's data
          const releaseAuditCycle = vendorCheckpointAuditCycles.find(
            (cycle: any) => getValue(cycle, "release_date_audit_cycle", null)
          )?.release_date_audit_cycle;
      
          // If no valid audit cycle exists, return empty
          if (!releaseAuditCycle) return "";
      
          // Date validation
          const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
          const startDate = releaseAuditCycle.start_date;
          const cutoffDate = releaseAuditCycle.cutoff_date;
      
          // Check if current date is within valid range
          if (today < startDate || today > cutoffDate) return "";
      
          // Get audit status directly from row data
          const auditStatus = getValue(row, "original.audit_status.props.children", "").toLowerCase();
          const documents = getValue(row.original, "documents", []);
          
          // Get upload status directly from the row data
          const uploadStatus = getValue(row.original, "upload_status", "NOT_UPLOADED");
      
          // Determine if action buttons should be shown
          if (["pending audit", "complied"].includes(auditStatus)) return null;
      
          const handleSubmit = () => {
            const id = row.original.id;
            const releaseCycleId = releaseAuditCycle.id;
      
            if (documents.length === 0 || uploadStatus !== "UPLOADED") {
              handleModal2();
              setSelectedIndex(id); // Track the current ID for comments
            } else {
              handleSubmitTask(id, releaseCycleId);
            }
          };
      
          return (
            <div className="d-flex gap-1">
              {/* Only show Upload Document button if upload_status is not UPLOADED */}
              {uploadStatus !== "UPLOADED" && (
                <button
                  className="btn common-button p-2 me-2"
                  onClick={() => handleModalUpload(row.original)}
                >
                  Upload Document
                </button>
              )}
      
              <button
                className="btn btn-primary p-2"
                onClick={handleSubmit}
                disabled={auditStatus === "pending audit"}
              >
                Submit
              </button>
            </div>
          );
        },
      }
      
      
    ],
    [paramsNew.date]
  );

  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  // const getTrProps = (rowInfo: any) => {
  //   if (getValue(rowInfo, `id`, "")) {
  //     return {
  //       style: {},
  //     };
  //   }
  //   return {};
  // };

  // const getTrProps = (state:any, rowInfo:any) => {
  //   if (!rowInfo) return {};

  //   const { original } = rowInfo;
  //   if (original.type === "documents") {
  //     return {
  //       style: {
  //         background: "#f9f9f9", // Optional: Differentiate document rows visually
  //       },
  //       // Custom rendering for document rows
  //       children: (
  //         <tr>
  //           <td colSpan={columns.length}>
  //             <div>
  //               <strong>Documents:</strong>{" "}
  //               {original.documents.length > 0
  //                 ? original.documents.map((doc:any, index:any) => (
  //                     <span key={index}>
  //                       {doc.name || `Document ${index + 1}`}
  //                       {index < original.documents.length - 1 ? ", " : ""}
  //                     </span>
  //                   ))
  //                 : "No documents uploaded"}
  //             </div>
  //           </td>
  //         </tr>
  //       ),
  //     };
  //   }
  //   return {}; // Default styling for data rows
  // };

  const getTrProps = (state: any, rowInfo: any) => {
    if (!rowInfo) return {};

    const { original } = rowInfo;

    if (original.type === "documents") {
      return {
        style: {
          background: "#f9f9f9", // Light background to differentiate
        },
        children: (
          <tr style={{ display: "flex", width: "100%", borderBottom: "0" }}>
            <td
              colSpan={columns.length}
              rowSpan={columns.length}
              style={{ width: "100%", borderBottom: "1px solid #dadce0" }}
            >
              <div style={{ padding: "8px", display: "flex", gap: "10px" }}>
                {/* <strong>Documents: </strong> */}
                {original.documents.length > 0
                  ? original.documents.map((doc: any, index: any) => (
                      <>
                        <div
                          className="uploaded-details-wrapper__agreement d-flex align-items-center"
                          style={{ minWidth: "150px" }}
                        >
                          <img
                            // onClick={() =>
                            // 	handleDeleteFile(
                            // 		getValue(uploadDetailsObj, `id`, ""),
                            // 		getValue(items, `id`, "")
                            // 	)
                            // }
                            src="/images/uploaded-details/word.svg"
                            className="img-fluid cursor-pointer"
                          />
                          <p
                            className="uploaded-details-wrapper__agreement-text text-truncate cursor-pointer"
                            onClick={() =>
                              handleDownloadOnClick(
                                getValue(doc, `key`, ""),
                                getValue(doc, `name`, "")
                              )
                            }
                          >
                            {getValue(doc, `name`, "")}
                            {getValue(doc, `extension`, "")}
                          </p>
                          {/* <img
                          src="/images/uploaded-details/close-grey.svg"
                          className="img-fluid cursor-pointer"
                        /> */}
                        </div>
                      </>
                    ))
                  : "No documents uploaded"}
              </div>
            </td>
          </tr>
        ),
      };
    }

    return {}; // Default for data rows
  };

  const getRowProps = (row: any) => {
    const original = row.original;

    if (original.type === "data") {
      if (original.documents && original.documents.length > 0) {
        return {
          style: { background: "transparent" }, // Default for data rows
        };
      }
      return {};
    }

    return {};
  };

  const renderRow = (row: any) => {
    if (row.original.type === "data") {
      return (
        <>
          {/* Render the main data row */}
          <tr>
            {row.getVisibleCells().map((cell: any) => (
              <td key={cell.id}>
                {row.getVisibleCells(
                  cell.column.columnDef.cell,
                  cell.getContext()
                )}
              </td>
            ))}
          </tr>
          {/* Render a single row for all documents if they exist */}
          {row.original.documents && row.original.documents.length > 0 && (
            <tr
              style={{
                background: "#f9f9f9",
                borderBottom: "1px solid #dadce0",
              }}
            >
              <td colSpan={columns.length} style={{ borderBottom: "0" }}>
                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  {row.original.documents.map((doc: any, index: any) => (
                    <div
                      key={index}
                      className="uploaded-details-wrapper__agreement d-flex align-items-center"
                      style={{ minWidth: "150px", maxWidth: "200px" }}
                    >
                      <img
                        src="/images/uploaded-details/word.svg"
                        className="img-fluid cursor-pointer"
                        style={{ marginRight: "8px" }}
                      />
                      <p
                        className="uploaded-details-wrapper__agreement-text text-truncate cursor-pointer"
                        onClick={() =>
                          handleDownloadOnClick(
                            getValue(doc, `key`, ""),
                            getValue(doc, `name`, "")
                          )
                        }
                        style={{ margin: 0, flex: 1 }}
                      >
                        {getValue(doc, `name`, "")}
                        {getValue(doc, `extension`, "")}
                      </p>
                    </div>
                  ))}
                </div>
              </td>
            </tr>
          )}
        </>
      );
    }
    return (
      <tr>
        {row.getVisibleCells().map((cell: any) => (
          <td key={cell.id}>
            {row.getVisibleCells(cell.column.columnDef.cell, cell.getContext())}
          </td>
        ))}
      </tr>
    );
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      date: params.date,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Filter section                               */
  /* -------------------------------------------------------------------------- */

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
      date: getValue(params, `date`, ""),
      view_type: params.view_type, // Preserve view_type
    };
    setRequest({
      ...request,
      state_id: "",
      city_id: "",
      // region_id: "",
      group_id: "",
      location_id: "",
      // vendor_id: "",
      audit_checkpoint_id: "",
      audit_type: "",
    });
    // getRegionsList("", "");
    getGroupsList("", "");
    getStatesList("", "", "");
    getCitiesList("", "", "", "");
    getLocationsList("", "", "", "", "");
    // getVendorList("", "", "", "", "", "", "");
    getAuditTypeList("", "", "", "", "", "", "");
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    // setFilterVisibility(false);
  };

  const handleSubmitSmartFilter = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      city_id: getValue(request, `city_id`, ""),
      region_id: getValue(request, `region_id`, ""),
      group_id: getValue(request, `group_id`, ""),
      location_id: getValue(request, `location_id`, ""),
      vendor_id: getValue(request, `vendor_id`, ""),
      audit_type: getValue(request, `audit_type`, ""),
      audit_checkpoint_id: getValue(request, `audit_checkpoint_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    // handleFilter();
    setFilterVisibility(false);
  };

  /* -------------------------------------------------------------------------- */
  /*                    smart Filter API section                                */
  /* -------------------------------------------------------------------------- */

  const [regionList, setRegionList] = useState([]);
  const [regionLoading, setRegionLoading] = useState(false);

  const getRegionsList = async (search_text: string, id: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        type: "REGION",
        search_text: search_text,
        region_id: id,
        is_redirect: true,
        userType: "VENDOR",
      };
      setRegionLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setRegionList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `region_id`, ""),
            label: getValue(item, `region_name`, ""),
            value: getValue(item, `region_name`, ""),
          }))
        );
        setRegionLoading(false);
      } else {
        setRegionLoading(false);
      }
    } catch (error) {
      setRegionLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   region_id: "",
      // });
      //   getGroupsList("", "");
      //   setGroupsList([]);
      //   getLocationsList("", "", "");
      //   setlocationsList([]);
      //   getVendorList("", "", "", "");
      //   setvendorsList([]);
    }
  };

  const [groupsList, setGroupsList] = useState([]);
  const [groupLoading, setGroupLoading] = useState(false);
  const getGroupsList = async (
    search_text: string,
    // region_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        // region_id: region_id,
        type: "GROUP",
        search_text: search_text,
        group_id: id,
        is_redirect: true,
        userType: "VENDOR",
      };
      setGroupLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setGroupsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `group_id`, ""),
            label: getValue(item, `group_name`, ""),
            value: getValue(item, `group_name`, ""),
          }))
        );
        setGroupLoading(false);
      } else {
        setGroupLoading(false);
      }
    } catch (error) {
      setGroupLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   group_id: null,
      // });
      //   getLocationsList("", "", "");
      //   setlocationsList([]);
      //   getVendorList("", "", "", "");
      //   setvendorsList([]);
    }
  };

  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const getStatesList = async (
    search_text: string,
    // region_id: string,
    group_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        // region_id: region_id,
        group_id: group_id,
        type: "STATE",
        search_text: search_text,
        state_id: id,
        is_redirect: true,
        userType: "VENDOR",
      };

      setStateLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setStateList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `state_id`, ""),
            label: getValue(item, `state_name`, ""),
            value: getValue(item, `state_name`, ""),
          }))
        );
        setStateLoading(false);
      } else {
        setStateLoading(false);
      }
    } catch (error) {
      setStateLoading(false);
    }
  };

  const [cityList, setCityList] = useState([]);
  const [cityLoading, setCityLoading] = useState(false);
  const getCitiesList = async (
    search_text: string,
    // region_id: string,
    group_id: string,
    state_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        // region_id: region_id,
        group_id: group_id,
        type: "CITY",
        search_text: search_text,
        state_id: state_id,
        city_id: id,
        is_redirect: true,
        userType: "VENDOR",
      };

      setCityLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setCityList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `city_id`, ""),
            label: getValue(item, `city_name`, ""),
            value: getValue(item, `city_name`, ""),
          }))
        );
        setCityLoading(false);
      } else {
        setCityLoading(false);
      }
    } catch (error) {
      setCityLoading(false);
    }
  };

  const [locationsList, setlocationsList] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const getLocationsList = async (
    search_text: string,
    // region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        // region_id: region_id,
        group_id: group_id,
        type: "LOCATION",
        search_text: search_text,
        state_id: state_id,
        city_id: city_id,
        location_id: id,
        is_redirect: true,
        userType: "VENDOR",
      };
      setLocationLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setlocationsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `location_id`, ""),
            label: getValue(item, `location_name`, ""),
            value: getValue(item, `location_name`, ""),
          }))
        );
        setLocationLoading(false);
      } else {
        setLocationLoading(false);
      }
    } catch (error) {
      setLocationLoading(false);
    }
  };

  const [vendorsList, setvendorsList] = useState([]);
  const [vendorLoading, setvendorLoading] = useState(false);
  const getVendorList = async (
    search_text: string,
    // region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        // region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        type: "VENDOR",
        search_text: search_text,
        vendor_id: id,
        is_redirect: true,
        userType: "VENDOR",
      };
      setvendorLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setvendorsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `vendor_id`, ""),
            label: getValue(item, `vendor_name`, ""),
            value: getValue(item, `vendor_name`, ""),
          }))
        );
        setvendorLoading(false);
      } else {
        setvendorLoading(false);
      }
    } catch (error) {
      setvendorLoading(false);
    }
  };

  const [auditCheckpointList, setAuditCheckpointList] = useState([]);
  const [auditCheckpointLoading, setAuditCheckpointLoading] = useState(false);
  const getAuditCheckpointList = async (
    search_text: string,
    // region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    // vendor_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        // region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        // vendor_id: vendor_id,
        type: "AUDIT_CHECKPOINT",
        search_text: search_text,
        vendor_checkpoint_id: id,
        page_size: 100,
        is_redirect: true,
        userType: "VENDOR",
      };
      setAuditCheckpointLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setAuditCheckpointList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `legislation_id`, ""),
            label: getValue(item, `legislation_rule`, ""),
            value: getValue(item, `legislation_rule`, ""),
          }))
        );
        setAuditCheckpointLoading(false);
      } else {
        setAuditCheckpointLoading(false);
      }
    } catch (error) {
      setAuditCheckpointLoading(false);
    }
  };

  const [auditTypeList, setAuditTypeList] = useState([]);
  const [auditTypeLoading, setAuditTypeLoading] = useState(false);
  const getAuditTypeList = async (
    search_text: string,
    // region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    // vendor_id: string,
    audit_checkpoint_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        // region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        // vendor_id: vendor_id,
        audit_checkpoint_id: audit_checkpoint_id,
        type: "AUDIT_TYPE",
        search_text: search_text,
        audit_type: id,
        page_size: 100,
        is_redirect: true,
        userType: "VENDOR",
      };
      setAuditTypeLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setAuditTypeList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `audit_status`, ""),
            label: formatText(getValue(item, `audit_status`, "")),
            value: getValue(item, `audit_status`, ""),
          }))
        );
        setAuditTypeLoading(false);
      } else {
        setAuditTypeLoading(false);
      }
    } catch (error) {
      setAuditTypeLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   vendor_id: "",
      // });
    }
  };

  let state_ID =
    getValue(stateList, `length`, 0) > 0 &&
    stateList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );

  let city_ID =
    getValue(cityList, `length`, 0) > 0 &&
    cityList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `city_id`, "")
    );
  let region_ID =
    getValue(regionList, `length`, 0) > 0 &&
    regionList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `region_id`, "")
    );

  let group_ID =
    getValue(groupsList, `length`, 0) > 0 &&
    groupsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `group_id`, "")
    );

  let location_ID =
    getValue(locationsList, `length`, 0) > 0 &&
    locationsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `location_id`, "")
    );

  let vendor_ID =
    getValue(vendorsList, `length`, 0) > 0 &&
    vendorsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `vendor_id`, "")
    );

  let audit_checkpoint_ID =
    getValue(auditCheckpointList, `length`, 0) > 0 &&
    auditCheckpointList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `audit_checkpoint_id`, "")
    );

  let audit_type_ID =
    getValue(auditTypeList, `length`, 0) > 0 &&
    auditTypeList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `audit_type`, "")
    );

  const handleRemoveFilter = (name: string) => {
    if (name === "region_id") {
      setRequest({
        ...request,
        // region_id: "",
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getGroupsList("", "");
      getStatesList("", "", "");
      getCitiesList("", "", "", "");
      getLocationsList("", "", "", "", "");
      getVendorList("", "", "", "", "", "");
      getAuditTypeList("", "", "", "", "", "", "");

      setGroupsList([]);
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "group_id") {
      setRequest({
        ...request,
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getGroupsList("", "");
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "state_id") {
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getStatesList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        ""
      );
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "city_id") {
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getCitiesList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        ""
      );
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "location_id") {
      setRequest({
        ...request,
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      // getGroupsList("", getValue(request, `region_id`, ""), "");
      getLocationsList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        ""
      );
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "vendor_id") {
      setRequest({
        ...request,
        // vendor_id: "",
        audit_checkpoint_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      // getGroupsList("", getValue(request, `region_id`, ""), "");
      // getLocationsList(
      //   "",
      //   getValue(request, `region_id`, ""),
      //   getValue(request, `group_id`, ""),
      //   ""
      // );
      getVendorList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        ""
      );
      setAuditCheckpointList([]);
      setAuditTypeList([]);
    }

    if (name === "audit_checkpoint_id") {
      setRequest({
        ...request,
        audit_checkpoint_id: "",
        audit_type: "",
      });

      getAuditCheckpointList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        // getValue(request, `vendor_id`, ""),
        ""
      );
      setAuditTypeList([]);
    }

    if (name === "audit_type") {
      setRequest({
        ...request,
        audit_type: "",
      });
      getAuditTypeList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),

        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),

        getValue(request, `location_id`, ""),
        // getValue(request, `vendor_id`, ""),
        getValue(request, `audit_checkpoint_id`, ""),
        ""
      );
    }
    getGroupsList("", "");
    getStatesList("", "", "");
    getCitiesList("", "", "", "");
    getLocationsList("", "", "", "", "");
    getVendorList("", "", "", "", "", "");
    getAuditTypeList("", "", "", "", "", "", "");
    // if (name === "vendor_id") {
    //   setRequest({
    //     ...request,
    //     vendor_id: "",
    //     audit_type: "",
    //   });
    //   // getRegionsList("", "");
    //   // getGroupsList("", getValue(request, `region_id`, ""), "");
    //   // getLocationsList(
    //   //   "",
    //   //   getValue(request, `region_id`, ""),
    //   //   getValue(request, `group_id`, ""),
    //   //   ""
    //   // );
    //   getVendorList(
    //     "",
    //     getValue(request, `region_id`, ""),
    //     getValue(request, `group_id`, ""),
    //     getValue(request, `state_id`, ""),
    //     getValue(request, `city_id`, ""),
    //     getValue(request, `location_id`, ""),
    //     ""
    //   );
    //   setAuditTypeList([]);
    // }
    // if (name === "audit_type") {
    //   setRequest({
    //     ...request,
    //     audit_type: "",
    //   });
    //   // getRegionsList("", "");
    //   // getGroupsList("", getValue(request, `region_id`, ""), "");
    //   // getLocationsList(
    //   //   "",
    //   //   getValue(request, `region_id`, ""),
    //   //   getValue(request, `group_id`, ""),
    //   //   ""
    //   // );
    //   // getVendorList(
    //   //   "",
    //   //   getValue(request, `region_id`, ""),
    //   //   getValue(request, `group_id`, ""),
    //   //   getValue(request, `location_id`, ""),
    //   //   ""
    //   // );
    //   getAuditTypeList(
    //     "",
    //     getValue(request, `region_id`, ""),
    //     getValue(request, `group_id`, ""),

    //     getValue(request, `state_id`, ""),
    //     getValue(request, `city_id`, ""),

    //     getValue(request, `location_id`, ""),
    //     getValue(request, `vendor_id`, ""),
    //     getValue(request, `audit_checkpoint_id`, ""),
    //     ""
    //   );
    // }
    // getRegionsList("", "");
    // getGroupsList("", "", "");
    // getStatesList("", "", "", "");
    // getCitiesList("", "", "", "", "");
    // getLocationsList("","","","","","");
    // getVendorList("","","","","","","");
    // getAuditTypeList("","","","","","","","");
  };

  const handleSelectFilter = (id: any, name: string) => {
    // if (name === "region_id") {
    //   getGroupsList("", id, "");
    //   setRequest({
    //     ...request,
    //     group_id: "",
    //     state_id: "",
    //     city_id: "",
    //     location_id: "",
    //     vendor_id: "",
    //     audit_type: "",
    //   });
    //   setGroupsList([]);
    //   setStateList([]);
    //   setCityList([]);
    //   setlocationsList([]);
    //   setvendorsList([]);
    //   setAuditTypeList([]);
    // }
    if (name === "group_id") {
      getStatesList("", id, "");
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "state_id") {
      getCitiesList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "city_id") {
      getLocationsList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "location_id") {
      // getVendorList(
      //   "",
      //   getValue(request, `region_id`, ""),
      //   getValue(request, `group_id`, ""),
      //   getValue(request, `state_id`, ""),
      //   getValue(request, `city_id`, ""),
      //   id,
      //   ""
      // );
      // setRequest({
      //   ...request,
      //   vendor_id: "",
      //   audit_type: "",
      // });
      // setvendorsList([]);
      // setAuditTypeList([]);

      getAuditCheckpointList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        // getValue(request, `location_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        audit_checkpoint_id: "",
        audit_type: "",
      });
      setAuditCheckpointList([]);
      setAuditTypeList([]);
    }

    // if (name === "vendor_id") {
    //   getAuditTypeList(
    //     "",
    //     getValue(request, `region_id`, ""),
    //     getValue(request, `group_id`, ""),
    //     getValue(request, `state_id`, ""),
    //     getValue(request, `city_id`, ""),
    //     getValue(request, `location_id`, ""),
    //     id,
    //     ""
    //   );
    //   setRequest({
    //     ...request,
    //     audit_type: "",
    //   });
    //   setAuditTypeList([]);
    // }
    // if (name === "vendor_id") {
    //   getAuditTypeList(
    //     "",
    //     getValue(request, `region_id`, ""),
    //     getValue(request, `group_id`, ""),
    //     getValue(request, `state_id`, ""),
    //     getValue(request, `city_id`, ""),
    //     getValue(request, `location_id`, ""),
    //     getValue(request, `audit_checkpoint_id`, ""),
    //     id,
    //     ""
    //   );
    // }

    if (name === "audit_checkpoint_id") {
      getAuditTypeList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        // getValue(request, `vendor_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        audit_checkpoint_id: "",
        audit_type: "",
      });
      // setAuditTypeList([]);
    }

    setRequest({
      ...request,
      [name]: id,
    });
  };

  const [isOpen1, setIsOpen1] = useState(false);
  const handleModal1 = () => {
    setIsOpen1(!isOpen1);
  };

  const handleModalUpload = (obj: object) => {
    setVendorInfo(obj);
    setSelectedIndex([getValue(obj, `id`, "")]);
    handleModal1();
  };

  const handleModalUploadCancel = () => {
    setVendorInfo({});
    handleModal1();
  };

  let selectedCheck = list.filter((item: any) => {
    if (selectedIndex.includes(getValue(item, `id`, ""))) return item;
  });

  let checkUpload: any =
    getValue(selectedCheck, `length`, 0) > 0
      ? selectedCheck.filter(
          (item: any) =>
            !getValue(item, `is_submitted`, "") ||
            getValue(item, `upload_status`, "") === "UPLOADED"
        )
      : [];

  const [isOpen2, setIsOpen2] = useState(false);
  const handleModal2 = () => {
    setIsOpen2(!isOpen2);
  };

  const handleModal2CloseIcon = () => {
    setSubmitLoading(false);
    setIsOpen2(!isOpen2);
  };

  const [selectedReleaseCycleIds, setSelectedReleaseCycleIds] = useState<
    string[]
  >([]);

  const handleChangeCheckbox = (
    id: string,
    releaseCycleId: string | undefined
  ) => {
    // alert("1");
    // console.log(id, releaseCycleId, "---id,releaseCycleId-->");
    setSelectedIndex((prev: any) => {
      const isSelected = prev.includes(id);
      if (isSelected) {
        // Remove id and corresponding releaseCycleId when unchecked
        setSelectedReleaseCycleIds((prevIds) =>
          prevIds.filter((cycleId) => cycleId !== releaseCycleId)
        );
        return prev.filter((item: any) => item !== id);
      } else {
        // Add id and corresponding releaseCycleId when checked
        if (releaseCycleId) {
          setSelectedReleaseCycleIds((prevIds) => [...prevIds, releaseCycleId]);
        }
        return [...prev, id];
      }
    });
  };

  // const handleSubmitTask = async (id:any) => {
  //   // alert(checkUpload.upload_status);

  //   // console.log(selectedReleaseCycleIds, "--selectedReleaseCycleIds-->");
  //   try {
  //     // if (comments) {
  //     setSubmitLoading(true);
  //     let payload = {
  //       ids: {id}, // Extract all `id` values from `selectedCheck`
  //       // ids: selectedCheck.map((item: any) => item.id), // Extract all `id` values from `selectedCheck`
  //       audit_status: "PENDING_AUDIT",
  //       commentsInfo: {
  //         comments: comments,
  //         type: "SUBMISSION_COMMENT",
  //         // audit_cycle: selectedReleaseCycleIds
  //       },
  //     };

  //     if (checkUpload.upload_status === "NOT_UPLOADED") {
  //       // setSelectedIndex([id]);
  //       // setReleaseCycleId(selectedReleaseCycleIds);
  //       handleModal2();
  //     } else {
  //       let resp = await submitVendorCheckpointTasks(payload);
  //       if (resp) {
  //         setSubmitLoading(false);
  //         toast.success("Submitted successfully");
  //         if (isOpen2) {
  //           setIsOpen2(!isOpen2);
  //         }
  //         if (checkUpload.upload_status === "NOT_UPLOADED") {
  //           // setSelectedIndex([id]);
  //           handleModal2();
  //         }
  //         setComments("");
  //         getData();
  //       }
  //     }
  //     setSelectedIndex([]);
  //     // } else {
  //     //   toast.error("Please add comments");
  //     //   setSubmitLoading(false);
  //     // }
  //   } catch (error) {
  //     setSubmitLoading(false);
  //   }
  // };

  const handleSubmitTask = async (id: string, releaseCycleId: string) => {
    try {
      setSubmitLoading(true);
      const payload = {
        ids: [id],
        audit_status: "PENDING_AUDIT",
        commentsInfo: {
          comments: comments,
          type: "SUBMISSION_COMMENT",
          audit_cycle: [releaseCycleId] // Include release cycle ID if needed
        },
      };
  
      const resp = await submitVendorCheckpointTasks(payload);
      if (resp) {
        toast.success("Submitted successfully");
        setComments("");
        getData();
      }
    } catch (error) {
      toast.error("Submission failed");
    } finally {
      setSubmitLoading(false);
    }
  };
  
  // Update comment submission handler
  const handleSubmitTaskComment = async () => {
    if (!comments) {
      toast.error("Please add comments");
      return;
    }
  
    try {
      setSubmitLoading(true);
      const payload = {
        ids: [selectedIndex], // Use the tracked ID from state
        audit_status: "PENDING_AUDIT",
        commentsInfo: {
          comments: comments,
          type: "SUBMISSION_COMMENT",
          audit_cycle: [] // Add cycle IDs if needed
        },
      };
  
      const resp = await submitVendorCheckpointTasks(payload);
      if (resp) {
        toast.success("Submitted successfully");
        setIsOpen2(false);
        setComments("");
        getData();
      }
    } catch (error) {
      toast.error("Submission failed");
    } finally {
      setSubmitLoading(false);
    }
  };

  
  // const handleSubmitTaskComment = async () => {
  //   try {
  //     // console.log(selectedReleaseCycleIds, "--selectedReleaseCycleIds-->");
  //     if (comments) {
  //       setSubmitLoading(true);
  //       let payload = {
  //         ids: selectedCheck.map((item: any) => item.id), // Extract all `id` values from `selectedCheck`
  //         audit_status: "PENDING_AUDIT",
  //         commentsInfo: {
  //           comments: comments,
  //           type: "SUBMISSION_COMMENT",
  //           // audit_cycle: selectedReleaseCycleIds
  //         },
  //       };

  //       if (checkUpload.upload_status === "NOT_UPLOADED") {
  //         // setSelectedIndex([id]);
  //         // setReleaseCycleId(selectedReleaseCycleIds);
  //         handleModal2();
  //       } else {
  //         let resp = await submitVendorCheckpointTasks(payload);
  //         if (resp) {
  //           setSubmitLoading(false);
  //           toast.success("Submitted successfully");
  //           if (isOpen2) {
  //             setIsOpen2(!isOpen2);
  //           }
  //           if (checkUpload.upload_status === "NOT_UPLOADED") {
  //             // setSelectedIndex([id]);
  //             handleModal2();
  //           }
  //           setComments("");
  //           getData();
  //         }
  //       }
  //       setSelectedIndex([]);
  //       // getDashboardInfo();
  //     } else {
  //       toast.error("Please add comments");
  //       setSubmitLoading(false);
  //     }
  //   } catch (error) {
  //     setSubmitLoading(false);
  //   }
  // };

    /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    

      let userSpec = getValue(localStorage, `user`, {});
      let user: any = JSON.parse(userSpec);
      let vendor_id = getValue(user, `vendor.id`, "");

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      status: getValue(params,`status`,''),
      sort_by: params.sort_by,
      date_range: [
        {
          month: params.date
          ? parseInt(params.date.split("-")[1])  // Ensuring month is an integer
          : date
          ? parseInt(moment(date).format("MM"))
          : parseInt(moment(dates).format("MM")),  
          year: params.date
            ? params.date.split("-")[0]
            : date
            ? moment(date).format("YYYY")
            : moment(dates).format("YYYY")
        }
      ],    
        is_redirect: "true",
        region_id: params.region_id,  
        group_id: params.group_id,  
        location_id: params.location_id,
        state_id: params.state_id,  
        city_id: params.city_id,  
        upload_status: params.update_status,
        vendor_id: params.vendor_id ? params.vendor_id : vendor_id, 
        audit_status: params.audit_type ? params.audit_type : params.audit_status,
        legislation_rule_id: params.audit_checkpoint_id,
        event_text: params.event_text,
        category_of_law_text: params.category_of_law_text,
        report_type: "VENDOR_AUDIT_COMPLIANCE",
        report_name: (
          convertDateAsString(from_date) +
          " " +
          "to" +
          " " +
          convertDateAsString(to_date)
        ).toString(),
        user_id:getValue(user,`id`,''),

    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    
    // let queryRequest = QueryRequestHelper(payload);
    setDownloadLoading(true);
    try {
      let resp = await downloadVendorComplianceMaster(payload);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/VENDOR_AUDIT_COMPLIANCE`);
        // handleDownloadOnClick(
        //   getValue(resp, `data.downloadUrl`, ""),
        //   "Show Cause Notice Report"
        // );
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };


  return (
    <>
      <DashboardLayout>
        <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
          <h4 className="dashbaord-wrapper__header-title">
            Linewise Item Report
          </h4>

          <div className="d-flex align-items-center">
            <CalenderDropdown
              onChange={setDate}
              value={date}
              handleSubmitDate={handleSubmitDate}
            />

            <div className="header-searchbar-wrapper ms-2">
              <SearchHeader
                addVisible={false}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                smartFilter={true}
                // isHeadingVisibleByDefault
                // isFilterHeadingVisible
                // headingText="Filter"
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                isFilterVisible={false}

                downloadSelfComplianceReport={true}
                handleDownloadSelfComplianceReport={
                  handleDownloadSelfComplianceReport
                }
                downloadLoading={downloadLoading}
              />
            </div>
          </div>
        </div>

        <div className="admin-wrapper position-relative">
          {/* {isFilterVisible && (
            <ReportsFilterForm
              setFilterFormVisibility={() => {
                setFilterVisibility(!isFilterVisible);
              }}
              reset={reset}
              handleSubmitSmartFilter={handleSubmitSmartFilter}
              // resetInput={resetInput}
              //region
              regionLoading={regionLoading}
              regionList={regionList}
              region_ID={region_ID}
              getRegionsList={getRegionsList}
              //group
              groupLoading={groupLoading}
              groupsList={groupsList}
              group_ID={group_ID}
              getGroupsList={getGroupsList}
              //state
              stateLoading={stateLoading}
              stateList={stateList}
              state_ID={state_ID}
              getStatesList={getStatesList}
              //city
              cityLoading={cityLoading}
              cityList={cityList}
              city_ID={city_ID}
              getCitiesList={getCitiesList}
              //location
              locationLoading={locationLoading}
              locationsList={locationsList}
              location_ID={location_ID}
              getLocationsList={getLocationsList}
              //configuration/vendors
              vendorLoading={vendorLoading}
              vendorsList={vendorsList}
              vendor_ID={vendor_ID}
              getVendorList={getVendorList}
              //audit_type
              auditTypeLoading={auditTypeLoading}
              auditTypeList={auditTypeList}
              audit_type_ID={audit_type_ID}
              getAuditTypeList={getAuditTypeList}

              request={request}

            /> */}

            <div className="filter-form-wrappper w-100 active filter-form-legal-update d-none">
              <div className="filter-form-wrappper__container">
                <div className="d-flex align-items-center justify-content-between my-3">
                  <h6 className="filter-form-wrappper__title">Filter by</h6>
                  <img
                    src="/images/close-black.svg"
                    className="img-fluid cursor-pointer"
                    onClick={() => {
                      // reset();
                      // setFilterFormVisibility();
                      setFilterVisibility(false);
                    }}
                  />
                </div>
                <div className="d-flex justify-content-between gap">
                  <div className="filter-form-wrappper__location flex-1">
                    {/* <div className="filter-form-wrappper__location-form-group form-group">
                      <label
                        htmlFor="state"
                        className="filter-form-wrappper__label"
                      >
                        Region
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <SearchableDropdownSelect
                          placeholder={`Select Region`}
                          options={regionList}
                          searchLoading={regionLoading}
                          handleChange={(val: any) =>
                            val
                              ? getRegionsList(val, "")
                              : handleRemoveFilter("region_id")
                          }
                          handleClick={(e: any) =>
                            handleSelectFilter(
                              getValue(e, `id`, ""),
                              "region_id"
                            )
                          }
                          value={
                            Array.isArray(region_ID) && region_ID.length > 0
                              ? region_ID[0]
                              : ""
                          }
                          label="label"
                          id="id"
                          name={"region_id"}
                        />
                      </div>
                    </div> */}

                    <div className="filter-form-wrappper__location-form-group form-group">
                      <label
                        htmlFor="state"
                        className="filter-form-wrappper__label"
                      >
                        Account
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <SearchableDropdownSelect
                          placeholder={`Select Account`}
                          options={groupsList}
                          searchLoading={groupLoading}
                          handleChange={(val: any) =>
                            val
                              ? getGroupsList(
                                  val,
                                  // getValue(request, `group_id`, ""),
                                  getValue(request, `group_id`, "")
                                )
                              : handleRemoveFilter("group_id")
                          }
                          handleClick={(e: any) =>
                            handleSelectFilter(
                              getValue(e, `id`, ""),
                              "group_id"
                            )
                          }
                          // value={group_ID}
                          value={
                            Array.isArray(group_ID) && group_ID.length > 0
                              ? group_ID[0]
                              : ""
                          }
                          label="label"
                          id="id"
                          name={"group_id"}
                        />
                      </div>
                    </div>

                    <div className="filter-form-wrappper__location-form-group form-group">
                      <label
                        htmlFor="state"
                        className="filter-form-wrappper__label"
                      >
                        Site
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <SearchableDropdownSelect
                          placeholder={`Select Site`}
                          options={locationsList}
                          searchLoading={locationLoading}
                          handleChange={(val: any) =>
                            val
                              ? getLocationsList(
                                  val,
                                  // getValue(request, `region_id`, ""),
                                  getValue(request, `group_id`, ""),
                                  getValue(request, `state_id`, ""),
                                  getValue(request, `city_id`, ""),
                                  ""
                                )
                              : handleRemoveFilter("location_id")
                          }
                          handleClick={(e: any) =>
                            handleSelectFilter(
                              getValue(e, `id`, ""),
                              "location_id"
                            )
                          }
                          // value={location_ID}
                          value={
                            Array.isArray(location_ID) && location_ID.length > 0
                              ? location_ID[0]
                              : ""
                          }
                          label="label"
                          id="id"
                          name={"location_id"}
                          // removeClose
                        />
                      </div>
                    </div>
                  </div>

                  <div className="filter-form-wrappper__location flex-1">
                    <div className="filter-form-wrappper__location-form-group form-group">
                      <label
                        htmlFor="state"
                        className="filter-form-wrappper__label"
                      >
                        State
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <SearchableDropdownSelect
                          placeholder={`Choose State`}
                          options={stateList}
                          searchLoading={stateLoading}
                          handleChange={(val: any) =>
                            val
                              ? getStatesList(
                                  val,
                                  // getValue(request, `region_id`, ""),
                                  getValue(request, `group_id`, ""),
                                  // getValue(props, `request.state_id`, ""),
                                  ""
                                )
                              : handleRemoveFilter("state_id")
                          }
                          handleClick={(e: any) =>
                            handleSelectFilter(
                              getValue(e, `id`, ""),
                              "state_id"
                            )
                          }
                          value={
                            Array.isArray(state_ID) && state_ID.length > 0
                              ? state_ID[0]
                              : ""
                          }
                          label="label"
                          id="id"
                          name={"state_id"}
                        />
                      </div>
                    </div>

                    <div className="filter-form-wrappper__location-form-group form-group">
                      <label
                        htmlFor="state"
                        className="filter-form-wrappper__label"
                      >
                        Audit Checkpoint
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <SearchableDropdownSelect
                          placeholder={`Select Audit Checkpoint`}
                          options={auditCheckpointList}
                          searchLoading={auditCheckpointLoading}
                          handleChange={(val: any) =>
                            val
                              ? getAuditCheckpointList(
                                  val,
                                  // getValue(request, `region_id`, ""),
                                  getValue(request, `group_id`, ""),
                                  getValue(request, `state_id`, ""),
                                  getValue(request, `city_id`, ""),
                                  getValue(request, `location_id`, ""),
                                  // getValue(request, `vendor_id`, ""),
                                  ""
                                )
                              : handleRemoveFilter("audit_checkpoint_id")
                          }
                          handleClick={(e: any) =>
                            handleSelectFilter(
                              getValue(e, `id`, ""),
                              "audit_checkpoint_id"
                            )
                          }
                          value={
                            Array.isArray(audit_checkpoint_ID) &&
                            audit_checkpoint_ID.length > 0
                              ? audit_checkpoint_ID[0]
                              : ""
                          }
                          label="label"
                          id="id"
                          name={"audit_checkpoint_ID"}
                          // removeClose
                        />
                      </div>
                    </div>
                  </div>

                  <div className="filter-form-wrappper__location flex-1">
                    <div className="filter-form-wrappper__location-form-group form-group">
                      <label
                        htmlFor="state"
                        className="filter-form-wrappper__label"
                      >
                        City
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <SearchableDropdownSelect
                          placeholder={`Choose City`}
                          options={cityList}
                          searchLoading={cityLoading}
                          handleChange={(val: any) =>
                            val
                              ? getCitiesList(
                                  val,
                                  // getValue(request, `region_id`, ""),
                                  getValue(request, `group_id`, ""),
                                  getValue(request, `state_id`, ""),
                                  // getValue(props, `request.city_id`, ""),
                                  ""
                                )
                              : handleRemoveFilter("city_id")
                          }
                          handleClick={(e: any) =>
                            handleSelectFilter(getValue(e, `id`, ""), "city_id")
                          }
                          // value={getValue(props, `city_ID[${0}]`, "")}
                          value={
                            Array.isArray(city_ID) && city_ID.length > 0
                              ? city_ID[0]
                              : ""
                          }
                          label="label"
                          id="id"
                          name={"city_id"}
                        />
                      </div>
                    </div>

                    <div className="filter-form-wrappper__location-form-group form-group">
                      <label
                        htmlFor="state"
                        className="filter-form-wrappper__label"
                      >
                        Audit Status
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <SearchableDropdownSelect
                          placeholder={`Choose Audit Status`}
                          options={auditTypeList}
                          searchLoading={auditTypeLoading}
                          handleChange={(val: any) =>
                            val
                              ? getAuditTypeList(
                                  val,
                                  // getValue(request, `region_id`, ""),
                                  getValue(request, `group_id`, ""),
                                  getValue(request, `state_id`, ""),
                                  getValue(request, `city_id`, ""),
                                  getValue(request, `location_id`, ""),
                                  // getValue(request, `vendor_id`, ""),
                                  getValue(request, `audit_checkpoint_id`, ""),
                                  ""
                                )
                              : handleRemoveFilter("audit_type")
                          }
                          handleClick={(e: any) =>
                            handleSelectFilter(
                              getValue(e, `id`, ""),
                              "audit_type"
                            )
                          }
                          // value={getValue(props, `audit_type_ID[${0}]`, "")}
                          value={
                            Array.isArray(audit_type_ID) &&
                            audit_type_ID.length > 0
                              ? audit_type_ID[0]
                              : ""
                          }
                          label="label"
                          id="id"
                          name={"audit_type"}
                          // removeClose
                        />
                      </div>
                    </div>

                    {/* <div className="filter-form-wrappper__location-form-group form-group">
                      <label
                        htmlFor="state"
                        className="filter-form-wrappper__label"
                      >
                        Vendor
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <SearchableDropdownSelect
                          placeholder={`Select Vendor`}
                          options={vendorsList}
                          searchLoading={vendorLoading}
                          handleChange={(val: any) =>
                            val
                              ? getVendorList(
                                  val,
                                  getValue(request, `region_id`, ""),
                                  getValue(request, `group_id`, ""),
                                  getValue(request, `state_id`, ""),
                                  getValue(request, `city_id`, ""),
                                  getValue(request, `location_id`, ""),
                                  ""
                                )
                              : handleRemoveFilter("vendor_id")
                          }
                          handleClick={(e: any) =>
                            handleSelectFilter(
                              getValue(e, `id`, ""),
                              "vendor_id"
                            )
                          }
                          value={
                            Array.isArray(vendor_ID) && vendor_ID.length > 0
                              ? vendor_ID[0]
                              : ""
                          }
                          label="label"
                          id="id"
                          name={"vendor_id"}
                          // removeClose
                          // disabled={disableVendor}
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>

              <div className="filter-form-wrappper__cta-wrapper">
                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
                  onClick={handleSubmitSmartFilter}
                >
                  Search
                </button>
                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
                  onClick={reset}
                >
                  Reset
                </button>
              </div>
              {/* <AddFilterNew /> */}
            </div>

            <div
              className={`filter-slidder-wrapper  ${
                isFilterVisible ? "filter-slidder-wrapper--active" : ""
              }`}
            >
              <div className="filter-form-wrappper w-100 active filter-form-legal-update">
                <div className="filter-form-wrappper__container">
                  <div className="filter-header-wrapper d-flex align-items-center justify-content-between">
                    <div className="filter-header-left-wrapper d-flex align-items-center">
                      <div className="filter-close-wrapper">
                        <img
                          src="/images/close-circle.svg"
                          className="img-fluid cursor-pointer"
                          onClick={() => {
                            setFilterVisibility(false);
                          }}
                        />
                      </div>
                      <div className="filter-title-wrapper">
                        <h6 className="filter-form-wrappper__title">Filter</h6>
                      </div>

                      <div className="filter-module-details-wrapper">
                        <div className="filter-module-name">Linewise Item Report</div>
                      </div>
                    </div>

                    <div className="filter-header-right-wrapper">
                      <div className="filter-form-wrappper__cta-wrapper p-0 d-flex">
                        <button
                          className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
                          onClick={reset}
                        >
                          <div className="d-flex align-items-center mt--3">
                            {/* <ResetSvgComponent size={24} color={"#5F6368"} />  */}
                            Reset
                          </div>
                        </button>

                        <button
                          className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--cancel"
                          onClick={() => {
                            setFilterVisibility(false);
                          }}
                        >
                          Cancel
                        </button>

                        <button
                          className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
                          onClick={handleSubmitSmartFilter}
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="filter-body-wrapper">
                    <div className="filter-body-card">
                      <div className="filter-card-title">Filter By</div>

                      <div className="d-flex justify-content-between flex-column">
                        <div className="filter-form-wrappper__location">
                          <div className="d-flex w-100 filter-field-main-wrap">
                            <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                              <label
                                htmlFor="state"
                                className="filter-form-wrappper__label"
                              >
                                Account
                              </label>
                              <div className="filter-form-wrappper__location-input select-dd-new">
                                <SearchableDropdownSelect
                                  placeholder={`Select Account`}
                                  options={groupsList}
                                  searchLoading={groupLoading}
                                  handleChange={(val: any) =>
                                    val
                                      ? getGroupsList(
                                          val,
                                          getValue(request, `group_id`, "")
                                          // ""
                                        )
                                      : handleRemoveFilter("group_id")
                                  }
                                  handleClick={(e: any) =>
                                    handleSelectFilter(
                                      getValue(e, `id`, ""),
                                      "group_id"
                                    )
                                  }
                                  // value={group_ID}
                                  value={
                                    Array.isArray(group_ID) && group_ID.length > 0
                                      ? group_ID[0]
                                      : ""
                                  }
                                  label="label"
                                  id="id"
                                  name={"group_id"}
                                />
                              </div>
                            </div>

                            <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                            <label
                              htmlFor="state"
                              className="filter-form-wrappper__label"
                            >
                              State
                            </label>
                            <div className="filter-form-wrappper__location-input select-dd-new">
                              <SearchableDropdownSelect
                                placeholder={`Choose State`}
                                options={stateList}
                                searchLoading={stateLoading}
                                handleChange={(val: any) =>
                                  val
                                    ? getStatesList(
                                        val,
                                        // getValue(request, `region_id`, ""),
                                        getValue(request, `group_id`, ""),
                                        // getValue(props, `request.state_id`, ""),
                                        ""
                                      )
                                    : handleRemoveFilter("state_id")
                                }
                                handleClick={(e: any) =>
                                  handleSelectFilter(
                                    getValue(e, `id`, ""),
                                    "state_id"
                                  )
                                }
                                value={
                                  Array.isArray(state_ID) && state_ID.length > 0
                                    ? state_ID[0]
                                    : ""
                                }
                                label="label"
                                id="id"
                                name={"state_id"}
                              />
                            </div>
                            </div>
                          </div>

                          <div className="d-flex w-100 filter-field-main-wrap">
                            <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                            <label
                              htmlFor="state"
                              className="filter-form-wrappper__label"
                            >
                              City
                            </label>
                            <div className="filter-form-wrappper__location-input select-dd-new">
                              <SearchableDropdownSelect
                                placeholder={`Choose City`}
                                options={cityList}
                                searchLoading={cityLoading}
                                handleChange={(val: any) =>
                                  val
                                    ? getCitiesList(
                                        val,
                                        // getValue(request, `region_id`, ""),
                                        getValue(request, `group_id`, ""),
                                        getValue(request, `state_id`, ""),
                                        // getValue(props, `request.city_id`, ""),
                                        ""
                                      )
                                    : handleRemoveFilter("city_id")
                                }
                                handleClick={(e: any) =>
                                  handleSelectFilter(getValue(e, `id`, ""), "city_id")
                                }
                                // value={getValue(props, `city_ID[${0}]`, "")}
                                value={
                                  Array.isArray(city_ID) && city_ID.length > 0
                                    ? city_ID[0]
                                    : ""
                                }
                                label="label"
                                id="id"
                                name={"city_id"}
                              />
                            </div>
                            </div>

                            <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                              <label
                                htmlFor="state"
                                className="filter-form-wrappper__label"
                              >
                                Site
                              </label>
                              <div className="filter-form-wrappper__location-input select-dd-new">
                                <SearchableDropdownSelect
                                  placeholder={`Select Site`}
                                  options={locationsList}
                                  searchLoading={locationLoading}
                                  handleChange={(val: any) =>
                                    val
                                      ? getLocationsList(
                                          val,
                                          // getValue(request, `region_id`, ""),
                                          getValue(request, `group_id`, ""),
                                          getValue(request, `state_id`, ""),
                                          getValue(request, `city_id`, ""),
                                          ""
                                        )
                                      : handleRemoveFilter("location_id")
                                  }
                                  handleClick={(e: any) =>
                                    handleSelectFilter(
                                      getValue(e, `id`, ""),
                                      "location_id"
                                    )
                                  }
                                  // value={location_ID}
                                  value={
                                    Array.isArray(location_ID) &&
                                    location_ID.length > 0
                                      ? location_ID[0]
                                      : ""
                                  }
                                  label="label"
                                  id="id"
                                  name={"location_id"}
                                  // removeClose
                                />
                              </div>
                            </div>
                          </div>

                          <div className="d-flex w-100 filter-field-main-wrap">
                            <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                            <label
                              htmlFor="state"
                              className="filter-form-wrappper__label"
                            >
                              Audit Checkpoint
                            </label>
                            <div className="filter-form-wrappper__location-input select-dd-new">
                              <SearchableDropdownSelect
                                placeholder={`Select Audit Checkpoint`}
                                options={auditCheckpointList}
                                searchLoading={auditCheckpointLoading}
                                handleChange={(val: any) =>
                                  val
                                    ? getAuditCheckpointList(
                                        val,
                                        // getValue(request, `region_id`, ""),
                                        getValue(request, `group_id`, ""),
                                        getValue(request, `state_id`, ""),
                                        getValue(request, `city_id`, ""),
                                        getValue(request, `location_id`, ""),
                                        // getValue(request, `vendor_id`, ""),
                                        ""
                                      )
                                    : handleRemoveFilter("audit_checkpoint_id")
                                }
                                handleClick={(e: any) =>
                                  handleSelectFilter(
                                    getValue(e, `id`, ""),
                                    "audit_checkpoint_id"
                                  )
                                }
                                value={
                                  Array.isArray(audit_checkpoint_ID) &&
                                  audit_checkpoint_ID.length > 0
                                    ? audit_checkpoint_ID[0]
                                    : ""
                                }
                                label="label"
                                id="id"
                                name={"audit_checkpoint_ID"}
                                // removeClose
                              />
                            </div>
                              </div>
                            
                            <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                            <label
                              htmlFor="state"
                              className="filter-form-wrappper__label"
                            >
                              Audit Status
                            </label>
                            <div className="filter-form-wrappper__location-input select-dd-new">
                              <SearchableDropdownSelect
                                placeholder={`Choose Audit Status`}
                                options={auditTypeList}
                                searchLoading={auditTypeLoading}
                                handleChange={(val: any) =>
                                  val
                                    ? getAuditTypeList(
                                        val,
                                        // getValue(request, `region_id`, ""),
                                        getValue(request, `group_id`, ""),
                                        getValue(request, `state_id`, ""),
                                        getValue(request, `city_id`, ""),
                                        getValue(request, `location_id`, ""),
                                        // getValue(request, `vendor_id`, ""),
                                        getValue(request, `audit_checkpoint_id`, ""),
                                        ""
                                      )
                                    : handleRemoveFilter("audit_type")
                                }
                                handleClick={(e: any) =>
                                  handleSelectFilter(
                                    getValue(e, `id`, ""),
                                    "audit_type"
                                  )
                                }
                                // value={getValue(props, `audit_type_ID[${0}]`, "")}
                                value={
                                  Array.isArray(audit_type_ID) &&
                                  audit_type_ID.length > 0
                                    ? audit_type_ID[0]
                                    : ""
                                }
                                label="label"
                                id="id"
                                name={"audit_type"}
                                // removeClose
                              />
                            </div>
                            </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="filter-form-wrappper__cta-wrapper">
                  <button
                    className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
                    onClick={handleSubmitSmartFilter}
                  >
                    Search
                  </button>
                  <button
                    className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
                    onClick={reset}
                  >
                    Reset
                  </button>
                </div>
                {/* <AddFilterNew /> */}
              </div>
            </div>

          {/* )} */}
          {isLoading ? (
            <Loader />
          ) : getValue(list, `length`, 0) > 0 ? (
            <ScrollableReactTable
              columns={columns}
              data={list}
              getTableState={getTableState}
              // rowClick={rowClick}
              check={check}
              selectedIDs={selectedIDs}
              checkboxlogo
              getTrProps={getTrProps}
            />
          ) : (
            // <CustomTable columns={columns} data={list} />
            <>
              {getValue(list, `length`, 0) !== 0 ? (
                <>
                  <Notfound />
                </>
              ) : (
                <Notfound />
              )}
            </>
          )}
        </div>

        {/* Marking Pagination as a d-none because in api im not getting pagination */}
        <div className="d-flex justify-content-between">
          {getValue(list, `length`, 0) > 0 && (
            <img
              src="/images/profile-illustration.svg"
              className="img-fluid px-5 py-3"
            />
          )}
          {totalCount > 10 ? (
            <PaginationPage
              totalCount={totalCount}
              limit={limit}
              pageNumber={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          ) : (
            <p className="show-rows-count mt-3 d-flex">
              Total Count:&nbsp;&nbsp;{" "}
              <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
            </p>
          )}
        </div>

        {isOpen1 && (
          <ReportsUploadModal
            // {...props}
            isOpen={isOpen1}
            handleModal={handleModalUploadCancel}
            vendorInfo={vendorInfo}
            getData={getData}
            mainParams={mainParams}
            selectedIndex={selectedIndex}
            handleSubmitTask={handleSubmitTask}
            // releaseCycleIds={releaseCycleIds}
          />
        )}

        {isOpen2 && (
          <Modal
            isOpen={isOpen2}
            toggle={() => handleModal2()}
            centered
            size="lg"
          >
            <div className="d-flex justify-content-between my-3">
              <div>
                {/* <h3>Add Comments for Submission</h3> */}
                <h3>
                  There is No Document attached! Do you still want to submit ?
                </h3>
              </div>
              <div>
                <img
                  src="/images/close-black.svg"
                  className="img-fluid cursor-pointer"
                  onClick={handleModal2CloseIcon}
                />
              </div>
            </div>
            <ModalBody>
              {/* <h5>There is No Document attached</h5> */}
              {/* <h6 className="mb-3">There is No Document attached! Do you still want to submit ?</h6> */}
              <div>
                <label htmlFor="" className="mb-1">
                  Add Comment *
                </label>
                <InputField
                  inputType="TEXTAREA"
                  value={comments}
                  onChange={(e: any) => setComments(e.target.value)}
                  rows="10"
                  placeholder="Add Comment"
                />
              </div>
            </ModalBody>
            <div className="d-flex justify-content-end m-3">
              <button
                className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
                onClick={() => handleModal2CloseIcon()}
              >
                Close
              </button>
              {/* {submitLoading ? (
                    <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                      Please wait...
                    </button>
                  ) : ( */}
              <button
                className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                onClick={handleSubmitTaskComment}
              >
                Submit for Audit Review
              </button>
              {/* )} */}
            </div>
          </Modal>
        )}
      </DashboardLayout>
    </>
  );
};

export default ReportsVendorCompliance;
